/* Live source: Judge.me's Shopify featured_carousel metafield.
   Keep the native widget as a fallback; never synthesize testimonial content. */
(() => {
  function setup(root) {
    if (root.dataset.ready) return;
    const source = root.querySelector('[data-shamma-review-source]');
    const initialCount = 6; // even, so the two-column desktop grid fills
    const seen = new Set();
    const reviews = [...source.querySelectorAll('.jdgm-carousel-item[data-review-id]')].filter(item => {
      const id = item.dataset.reviewId;
      if (seen.has(id)) return false;
      seen.add(id);
      return Boolean(item.querySelector('.jdgm-carousel-item__review-body')?.textContent.trim() || item.querySelector('.jdgm-carousel-item__review-title')?.textContent.trim());
    });
    if (!reviews.length) return;
    root.dataset.ready = 'true';
    const list = document.createElement('div');
    list.className = 'shamma-reviews__list';
    const make = (tag, cls, text) => {
      const node = document.createElement(tag);
      node.className = cls;
      if (text) node.textContent = text;
      return node;
    };
    reviews.forEach((item, index) => {
      const text = selector => item.querySelector(selector)?.textContent.trim() || '';
      const card = make('article', 'shamma-reviews__card shamma-reviews__card--live');
      card.dataset.reviewId = item.dataset.reviewId;
      card.hidden = index >= initialCount;
      const body = make('div', 'shamma-reviews__body');
      const ratingLabel = item.querySelector('.jdgm-carousel-item__review-rating')?.getAttribute('aria-label');
      const rating = parseFloat(ratingLabel);
      if (Number.isFinite(rating) && rating >= 0 && rating <= 5) {
        const stars = make('span', 'shamma-live-stars', '★★★★★');
        stars.setAttribute('role', 'img');
        stars.setAttribute('aria-label', ratingLabel);
        stars.style.setProperty('--rating', `${rating / 5 * 100}%`);
        body.append(stars);
      }
      const title = text('.jdgm-carousel-item__review-title');
      if (title) body.append(make('h3', 'shamma-reviews__title', title));
      const meta = make('p', 'shamma-reviews__meta');
      const author = text('.jdgm-carousel-item__reviewer-name');
      if (author) meta.append(make('span', 'shamma-reviews__author', author));
      const date = item.querySelector('.jdgm-carousel-item__timestamp')?.dataset.time;
      const parts = date?.match(/^(\d{2})\/(\d{2})\/(\d{4})$/);
      if (parts) {
        const timestamp = new Date(Number(parts[3]), Number(parts[1]) - 1, Number(parts[2]));
        const time = make('time', 'shamma-reviews__date', timestamp.toLocaleDateString(document.documentElement.lang || 'en', {year:'numeric',month:'long',day:'numeric'}));
        time.dateTime = `${parts[3]}-${parts[1]}-${parts[2]}`;
        meta.append(time);
      }
      body.append(meta);
      // Copy text only; preserve paragraph and explicit line breaks without injecting HTML.
      const original = item.querySelector('.jdgm-carousel-item__review-body');
      if (original) {
        const copy = original.cloneNode(true);
        copy.querySelectorAll('br').forEach(br => br.replaceWith('\n'));
        copy.querySelectorAll('p').forEach(p => p.append('\n\n'));
        const paragraphs = copy.textContent.replace(/\r\n?/g, '\n').split(/\n+/).map(part => part.trim()).filter(Boolean);
        const content = make('div', 'shamma-reviews__text');
        paragraphs.forEach(paragraph => content.append(make('p', '', paragraph)));
        body.append(content);
        if (content.textContent.length > 420) {
          content.id = `${root.closest('section').id}-review-${index}`;
          content.classList.add('shamma-reviews__text--collapsed');
          const expand = make('button', 'shamma-reviews__expand', 'Read full review');
          expand.type = 'button';
          expand.setAttribute('aria-expanded', 'false');
          expand.setAttribute('aria-controls', content.id);
          expand.addEventListener('click', () => {
            const collapsed = content.classList.toggle('shamma-reviews__text--collapsed');
            expand.setAttribute('aria-expanded', String(!collapsed));
            expand.textContent = collapsed ? 'Read full review' : 'Show less';
          });
          body.append(expand);
        }
      }
      card.append(body);
      addProductPhoto(item, card, root);
      list.append(card);
    });
    root.append(list);
    source.hidden = true;
    loadCustomerPhotos(root, list);
    if (reviews.length > initialCount) {
      let visible = initialCount;
      const more = make('button', 'sh-v2-button sh-v2-button--secondary sh-v2-button--small shamma-reviews__more', 'Show more reviews');
      more.type = 'button';
      const status = make('p', 'visually-hidden');
      status.setAttribute('role', 'status');
      more.addEventListener('click', () => {
        const firstNew = list.children[visible];
        visible = Math.min(visible + 4, reviews.length);
        [...list.children].forEach((card, index) => { card.hidden = index >= visible; });
        status.textContent = `Showing ${visible} of ${reviews.length} featured reviews`;
        if (visible === reviews.length) more.hidden = true;
        firstNew.tabIndex = -1;
        firstNew.focus({preventScroll:true});
      });
      root.append(more, status);
    }
  }
  function addBrandPlaceholder(root, card) {
    if (!root.dataset.reviewPlaceholder || card.querySelector('.shamma-reviews__media')) return;
    try {
      const url = new URL(root.dataset.reviewPlaceholder, window.location.origin);
      // The storefront serves the favicon over https; the theme dev preview
      // serves it from its own http origin, which is equally trusted.
      if (url.protocol !== 'https:' && url.origin !== window.location.origin) return;
      const figure = document.createElement('figure');
      figure.className = 'shamma-reviews__media shamma-reviews__brand-placeholder';
      const image = document.createElement('img');
      image.alt = 'Shamma lightning bolt — review placeholder';
      image.width = 320; image.height = 320; image.loading = 'lazy'; image.decoding = 'async';
      image.addEventListener('error', () => figure.remove(), {once: true});
      image.src = url.href;
      figure.append(image); card.prepend(figure);
    } catch { /* A missing favicon must not hide the review itself. */ }
  }
  function addProductPhoto(item, card, root) {
    // The carousel attaches this image to this exact review's product.
    // Reviews without a usable product image use the configured Shamma favicon.
    const source = item.querySelector('.jdgm-carousel-item__product-image');
    if (!source) { addBrandPlaceholder(root, card); return; }
    try {
      const url = new URL(source.getAttribute('data-src-retina') || source.getAttribute('data-src') || source.getAttribute('src'), window.location.origin);
      if (url.protocol !== 'https:' || url.hostname !== 'cdn.shopify.com' || !url.pathname.startsWith('/s/files/1/1042/9326/')) { addBrandPlaceholder(root, card); return; }
      url.pathname = url.pathname.replace(/_(?:70x70|140x140)(\.[a-z0-9]+)$/i, '_320x320$1');
      const figure = document.createElement('figure');
      figure.className = 'shamma-reviews__media shamma-reviews__product-photo';
      const image = document.createElement('img');
      image.alt = `${source.alt || 'Shamma sandals'} — product photo`;
      image.width = 320; image.height = 320; image.loading = 'lazy'; image.decoding = 'async';
      image.addEventListener('error', () => { figure.remove(); addBrandPlaceholder(root, card); }, {once: true});
      image.src = url.href;
      figure.append(image); card.prepend(figure);
    } catch { addBrandPlaceholder(root, card); }
  }
  async function loadCustomerPhotos(root, list) {
    // Public endpoint used by Judge.me's own all-reviews widget. No API credentials.
    // Replace product fallbacks only with genuine customer uploads matched by exact review ID.
    const controller = new AbortController();
    const timeout = setTimeout(() => controller.abort(), 8000);
    try {
      const endpoint = new URL('https://cdn.judge.me/reviews/all_reviews_js_based');
      endpoint.search = new URLSearchParams({shop_domain: root.dataset.shopDomain,
        platform: 'shopify', review_type: 'all-reviews', sort_by: 'with_pictures',
        per_page: '25', page: '1'}).toString();
      const response = await fetch(endpoint, {signal: controller.signal, credentials: 'omit'});
      if (!response.ok) throw new Error('Review media unavailable');
      const payload = await response.json();
      if (typeof payload.html !== 'string') throw new Error('Missing review media');
      // Template content stays inert: no remote HTML is inserted into the page.
      const template = document.createElement('template');
      template.innerHTML = payload.html;
      const cards = new Map([...list.children].map(card => [card.dataset.reviewId, card]));
      template.content.querySelectorAll('.jdgm-rev[data-review-id]').forEach(review => {
        const card = cards.get(review.dataset.reviewId);
        if (!card || card.querySelector('.shamma-reviews__customer-photo')) return;
        const upload = review.querySelector('.jdgm-rev__pics .jdgm-rev__pic-link:not(.jdgm-rev__product-picture)');
        if (!upload) return;
        try {
          const original = new URL(upload.getAttribute('href'));
          // This store's published uploads use Judge.me's review-image CDN.
          if (original.protocol !== 'https:' || original.hostname !== 'review-images.judgeme.com' || !original.pathname.startsWith('/shamma-sandals/')) return;
          const thumbnail = new URL(original.href);
          thumbnail.searchParams.set('width', '600');
          const figure = document.createElement('figure');
          figure.className = 'shamma-reviews__media shamma-reviews__customer-photo';
          const link = document.createElement('a');
          link.href = original.href;
          link.target = '_blank';
          link.rel = 'noopener noreferrer';
          const image = document.createElement('img');
          const author = card.querySelector('.shamma-reviews__author')?.textContent || 'this customer';
          image.alt = `Photo submitted with ${author}'s review (opens full image)`;
          image.width = 320; image.height = 320; image.decoding = 'async';
          // Keep the product fallback until the customer upload has loaded successfully.
          image.addEventListener('load', () => {
            const fallback = card.querySelector('.shamma-reviews__media');
            if (fallback) fallback.replaceWith(figure);
            else card.prepend(figure);
          }, {once: true});
          link.append(image); figure.append(link);
          image.src = thumbnail.href;
        } catch { /* An invalid optional image leaves the review text intact. */ }
      });
      root.dataset.photoStatus = 'loaded';
    } catch {
      // Reviews remain usable when the optional public media feed is unavailable.
      root.dataset.photoStatus = 'unavailable';
    } finally {
      clearTimeout(timeout);
    }
  }
  document.querySelectorAll('[data-shamma-live-reviews]').forEach(setup);
  document.addEventListener('shopify:section:load', event => event.target.querySelectorAll('[data-shamma-live-reviews]').forEach(setup));
})();
